import React from "react";
import PredictionPage from "../../components/PredictionPage";

function EURUSD() {
  return (
    <PredictionPage
      title="EURUSD"
      content="This is the EURUSD AI Trading Predictions page."
      canonical="/forex-majors/eurusd-ai-trading-predictions"
      categoryKey="nav.forexMajors"
      categoryPath="/forex-majors"
      symbol="EURUSD"
    />
  );
}

export default EURUSD;
